import ReactOnRails from 'react-on-rails';

import {
    GOVUKInitAll,
    ClearCookies,
} from 'dvla-external-frontend';
import CardsPage from '../bundles/CardsPage.tsx';
import OrderSummaryBox from '../bundles/shared/OrderSummaryBox.tsx';

ReactOnRails.register({
    CardsPage,
    OrderSummaryBox,
});

require.context('../stylesheets/', true, /^\.\/[^_].*\.(css|scss|sass)$/i);

// ensure images are included in the compiled pack
require.context('../images', true);
// ensure dvla-external-frontend/dist/media are included in the compiled pack
require.context('dvla-external-frontend/dist/media', true);

GOVUKInitAll();
ClearCookies.init();
